// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
import $ from 'virt_jquery_all';
import etask from 'zetask';
export var logout_sessions = (opt = {}) => {
  var on_success = opt.on_success,
    on_error = opt.on_error,
    cb = opt.cb;
  return etask(function* _logout_sessions() {
    try {
      var res = yield $.post('/users/logout/others');
      if (res != 'ok') throw new Error('Fail');
      on_success && on_success();
    } catch (e) {
      on_error && on_error();
    }
    cb && cb();
  });
};